<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To my family, I love you. Thank you for believing in me and supporting my life’s purpose.</p><br/>
<p style="text-align: center;">To every person I’ve crossed paths with, thank you for being a catalyst for me to dive into the unknown within, so I can heal and understand who I am, rise in love, and experience a wholehearted life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?b9eaac0c